module.exports = __webpack_public_path__ + "static/media/Orinocco96.549754e5.jpg";